var map = {
	"./blue/banner/loto-590.png": 4461,
	"./blue/banner/loto.png": 302,
	"./blue/banner/sports.png": 3735,
	"./darkblue/banner/banner-logo.png": 4039,
	"./darkblue/banner/instant-lotto.png": 1689,
	"./darkblue/banner/lotto-daily.png": 2341,
	"./darkblue/banner/sports.png": 8860,
	"./orange/banner/number.png": 6065,
	"./orange/banner/sports.png": 4542
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 895;